import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { VacationRequestForm } from "@/components/VacationRequestForm";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";


import { WelcomeSection } from "@/components/dashboard/WelcomeSection";
import { AdminSection } from "@/components/dashboard/AdminSection";
import { useDashboardData } from "@/hooks/useDashboardData";
import { TeamCalendar } from "@/components/admin/TeamCalendar";
import { DashboardHeader } from "@/components/dashboard/DashboardHeader";
import { Footer } from "@/components/ui/footer";
import { FullScreenLoader } from "@/components/ui/full-screen-loader";
import { ViewModeProvider, useViewMode } from "@/contexts/ViewModeContext";
import { UpcomingVacationsCarousel } from "@/components/dashboard/UpcomingVacationsCarousel";
import { useRealtimeSubscriptions } from "@/hooks/useRealtimeSubscriptions";

const DashboardContent = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const {
    profile,
    isProfileLoading,
    nextVacation,
    currentlyOnVacation,
    remainingVacationDays,
    vacationDuration,
    isAdmin
  } = useDashboardData();
  const { isViewingAsUser } = useViewMode();
  useRealtimeSubscriptions();

  // Effective admin status considers the view mode toggle
  const effectiveIsAdmin = isAdmin && !isViewingAsUser;

  const handleSignOut = async () => {
    try {
      await supabase.auth.signOut();
      navigate("/login");
      toast({
        title: "Signed out successfully",
      });
    } catch (error) {
      toast({
        title: "Error signing out",
        variant: "destructive",
      });
    }
  };

  if (isProfileLoading) {
    return <FullScreenLoader />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <DashboardHeader profile={profile} onSignOut={handleSignOut} isAdmin={isAdmin} />
      <div className="flex-1" style={{ 
        background: 'linear-gradient(109.6deg, rgba(223,234,247,1) 11.2%, rgba(244,248,252,1) 91.1%)'
      }}>
        <div className="max-w-7xl mx-auto px-8 py-10 space-y-8">
          <WelcomeSection
            profile={profile}
            remainingDays={remainingVacationDays}
            nextVacation={nextVacation || null}
            vacationDuration={vacationDuration}
            currentlyOnVacation={currentlyOnVacation || []}
          />

          <UpcomingVacationsCarousel />

          {!effectiveIsAdmin && <VacationRequestForm />}

          <Card className="p-6 hover:shadow-lg transition-shadow duration-300">
            <CardHeader>
              <CardTitle>
                Team Calendar
                <span className="block text-sm text-muted-foreground font-normal">
                  View team members' vacation schedules
                </span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <TeamCalendar />
            </CardContent>
          </Card>

          {effectiveIsAdmin && <AdminSection />}
        </div>
      </div>
      <Footer />
    </div>
  );
};

const Dashboard = () => {
  return (
    <ViewModeProvider>
      <DashboardContent />
    </ViewModeProvider>
  );
};

export default Dashboard;
